var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-up--form card card--lg"},[(_vm.step === 'UPDATE')?_c('address-update-form',{attrs:{"user":_vm.user}}):_vm._e(),_vm._v(" "),(_vm.step === 'VALID')?_c('address-update-valid'):_vm._e(),_vm._v(" "),(_vm.step === 'UNVALID')?_c('address-update-unvalid'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }